import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { isMobileOnly } from 'react-device-detect';

import createMessagingService from 'services/MessagingService/MessagingService';
import { GET_SIMILAR_CAMS } from 'services/MessagingService/EventNames';
import CookieStorageService from 'services/CookieStorageService';
import ProfileStore from 'stores/ProfileStore';
import ACCESS_LEVEL_NUM from 'enum/accessLevelsNum';
import { resolveGenderPreference } from 'utils/helpers';
import { MINUTE_AS_MILLISECONDS } from 'enum/timeFormat';
import { getGenderStr } from 'utils/gender';

import SimilarBroadcastsDesktop from './SimilarBroadcastsDesktop';
import SimilarBroadcastsMobile from './SimilarBroadcastsMobile';


const REFRESH_CAMS_RATE = 4 * MINUTE_AS_MILLISECONDS;

const SimilarBroadcasts = ({ user }) => {
  const messagingService = createMessagingService();
  const [similarCams, setSimilarCams] = useState([]);
  const { accessLevel, username } = user;
  const isAdmin = accessLevel > ACCESS_LEVEL_NUM.USER_MODERATOR;

  let genderPreference = resolveGenderPreference(user);
  // If the viewer is a guest, trying to obtain stored gender preference
  if (!user.user.getIn(['user', 'genderPreference']) && CookieStorageService.get('cam4-CONTENT')) {
    const contentPref = CookieStorageService.get('cam4-CONTENT');
    genderPreference = getGenderStr(contentPref);
  }

  const approvedAccounts = {};

  const handleFetchCams = useCallback((response) => {
    if (response?.users) {
      setSimilarCams(response.users);
    }
  }, []);

  useEffect(() => {
    messagingService.on(GET_SIMILAR_CAMS, handleFetchCams);
    ProfileStore.getSimilarCams(username, genderPreference);

    return () => {
      messagingService.off(GET_SIMILAR_CAMS, handleFetchCams);
    };
  }, [handleFetchCams, messagingService, username, genderPreference]);
  useEffect(() => {
    const interval = setInterval(() => {
      ProfileStore.getSimilarCams(username, genderPreference);
    }, REFRESH_CAMS_RATE);

    return () => clearInterval(interval);
  }, [username, genderPreference]);

  return isMobileOnly ? (
    <SimilarBroadcastsMobile
      accessLevel={accessLevel}
      approvedAccounts={approvedAccounts}
      genderPreference={genderPreference}
      isAdmin={isAdmin}
      similarCams={similarCams}
    />
  ) : (
    <SimilarBroadcastsDesktop
      accessLevel={accessLevel}
      approvedAccounts={approvedAccounts}
      genderPreference={genderPreference}
      isAdmin={isAdmin}
      similarCams={similarCams}
    />
  );
};

SimilarBroadcasts.propTypes = { user: PropTypes.object.isRequired };

export default observer(SimilarBroadcasts);
